import React, { Component, Fragment } from 'react';

import EmailReportConfigApi from 'apis/EmailReportConfig';
import BusinessApi from 'apis/Business';
import Toaster from 'components/Toaster';
import SMSAlertConfig from 'components/emailConfig/SMSAlertConfig';
import { SMS_ALERT_TYPES, SMS_ALERT_OBJECTS } from 'constants/smsAlerts';
import BusinessUsersApi from '../../apis/BusinessUsers';
import { getUserId } from '../../constants/localStorageManager';

class TextSmasAlert extends Component {
  constructor() {
    super();
    this.state = {
      id: null,
      is_active: '',
      report_type: '',
      sms_alert_number: '',
      business_name: '',
      userName: '',
      userRole: '',
      alert_type: [],
    };
  }

  componentDidMount() {
    this.fetchSmsAlertConfig();
  }

  handleOnCheck = () => {
    this.setState(prevState => ({ is_active: !prevState.is_active }));
  };

  checkDisabled = value => {
    const { alert_type } = this.state;
    const selectedType = SMS_ALERT_OBJECTS.find(obj =>
      alert_type.includes(obj.value)
    );

    return selectedType && selectedType.disabledFields.includes(value);
  };

  getAlertTypeValue = value => {
    const { alert_type } = this.state;
    let alertType = [...alert_type, value];
    const selectedType = SMS_ALERT_OBJECTS.find(obj => obj.value === value);
    selectedType.disabledFields.forEach(field => {
      if (alertType.includes(field))
        alertType = alertType.filter(type => type !== field);
    });

    return alertType;
  };

  handleOnSelect = e => {
    const { name, value, checked } = e.target;
    const { alert_type } = this.state;
    const isDisabled = this.checkDisabled(value);
    if (isDisabled) return;
    const alertType = checked
      ? this.getAlertTypeValue(value)
      : alert_type.filter(type => type !== value);
    this.setState({ alert_type: alertType });
  };

  fetchSmsAlertConfig = () => {
    EmailReportConfigApi.getPersonalSmsAlertConfig().then(({ data }) => {
      const { alert_type } = data;
      const alertType = alert_type || [];
      this.setState({
        ...data,
        userName: data.user_name,
        userRole: data.user_role,
        alert_type: alertType,
      });
    });
  };

  updateSmsAlertConfig = () => {
    const { id, alert_type } = this.state;
    const is_active = alert_type.length > 0;

    if (!id) return;
    EmailReportConfigApi.updatePersonalSmsAlertConfig(id, alert_type, is_active)
      .then(({ data }) => {
        this.fetchSmsAlertConfig();
        Toaster.getSuccessToaster(
          'check-circle',
          'Successfully updated sms alert settings'
        );
      })
      .catch(error =>
        Toaster.getFailureToaster(
          error,
          'exclamation-triangle',
          'Failed to update settings'
        )
      );
  };

  updateAlertPhoneNumber = smsAlertNumber => {
    const { business_user_id } = this.state;
    const userId = getUserId();
    BusinessUsersApi.updateSmsAlertNumber(userId, smsAlertNumber)
      .then(({ data }) => {
        Toaster.getSuccessToaster(
          'check-circle',
          'Successfully updated phone numnber'
        );
      })
      .catch(error =>
        Toaster.getFailureToaster(
          error,
          'exclamation-triangle',
          'Failed to update settings'
        )
      );
  };

  render() {
    const {
      is_active,
      alert_type,
      business_name,
      userName,
      userRole,
      sms_alert_number,
    } = this.state;

    return (
      <div>
        <p>
          <h2>{business_name}</h2>
          Text/SMS Alerts help you stay on top of your survey results through
          SMS notifications.
          <br />
          You can select and customize the types of alerts you would like to
          receive below.
        </p>
        <SMSAlertConfig
          userName={userName}
          userRole={userRole}
          is_active={is_active}
          alert_type={alert_type}
          handleOnCheck={this.handleOnCheck}
          handleOnSelect={this.handleOnSelect}
          updateSmsAlertConfig={this.updateSmsAlertConfig}
          updateAlertPhoneNumber={this.updateAlertPhoneNumber}
          checkboxLabel="Turn on Survey Email Reports"
          types={SMS_ALERT_OBJECTS}
          name="alert_type"
          sms_alert_number={sms_alert_number}
        />
      </div>
    );
  }
}

export default TextSmasAlert;



// WEBPACK FOOTER //
// ./src/components/emailConfig/TextSmsAlert.js